/**
 * Lógica compartida de Pepa (rediseño, flujo 3): preguntas y mapa de planes.
 * Client-safe (sin dependencias de servidor).
 */

export interface PreguntaPepa {
  q: string;
  opts: string[];
}

export const PREGUNTAS: PreguntaPepa[] = [
  {
    q: "¿Cómo te has sentido esta semana?",
    opts: ["Sin energía", "Digestión pesada", "Me enfermo seguido", "Quiero bajar de peso"],
  },
  {
    q: "¿Cuántas porciones de fruta o verdura comes al día?",
    opts: ["Casi ninguna", "1 o 2", "3 o más"],
  },
  {
    q: "¿A qué hora tomarías tu jugo?",
    opts: ["Al despertar", "Media mañana", "Después de entrenar", "En la noche"],
  },
  {
    q: "¿Algo que debamos evitar?",
    opts: ["Lácteos", "Azúcar", "Cafeína", "Nada, dale"],
  },
];

export interface LineaPlan {
  slug: string;
  qty: number;
  when: string;
}

/**
 * Plan de 14 días según la primera respuesta (mapa del prototipo, adaptado a
 * los slugs del catálogo sembrado).
 */
export function planPara(respuesta1: string | undefined): LineaPlan[] {
  const mapa: Record<string, LineaPlan[]> = {
    "Sin energía": [
      { slug: "beet-boost", qty: 4, when: "1 al día, en ayunas" },
      { slug: "cacao-fuerza", qty: 3, when: "Después de entrenar" },
      { slug: "naranja-escudo", qty: 2, when: "Cuando bajes de energía" },
    ],
    "Digestión pesada": [
      { slug: "pina-detox", qty: 5, when: "1 al día, media mañana" },
      { slug: "verde-vital", qty: 4, when: "En ayunas" },
      { slug: "sandia-fresh", qty: 2, when: "En la noche" },
    ],
    "Me enfermo seguido": [
      { slug: "naranja-escudo", qty: 5, when: "1 al día, en ayunas" },
      { slug: "verde-vital", qty: 3, when: "Media mañana" },
      { slug: "mango-glow", qty: 2, when: "En la tarde" },
    ],
    "Quiero bajar de peso": [
      { slug: "verde-vital", qty: 6, when: "En ayunas, 5 días" },
      { slug: "pina-detox", qty: 4, when: "Antes de almorzar" },
      { slug: "sandia-fresh", qty: 2, when: "En la noche" },
    ],
  };
  return mapa[respuesta1 ?? ""] ?? mapa["Sin energía"];
}

// ---------------------------------------------------------------------------
// Plan armado por la Pepa CONVERSACIONAL (Gemini) — persistencia ligera.
// ---------------------------------------------------------------------------

export interface LineaPlanIA {
  slug: string;
  unidades: number;
  cuando: string;
}

export function guardarPlanIA(plan: LineaPlanIA[], nota: string): void {
  try {
    sessionStorage.setItem("fz_pepa_plan", JSON.stringify({ plan, nota }));
  } catch {}
}

export function leerPlanIA(): { plan: LineaPlanIA[]; nota: string } | null {
  try {
    const crudo = sessionStorage.getItem("fz_pepa_plan");
    return crudo ? (JSON.parse(crudo) as { plan: LineaPlanIA[]; nota: string }) : null;
  } catch {
    return null;
  }
}

/** Persistencia ligera de las respuestas entre pantallas del flujo clásico. */
export function guardarRespuestas(respuestas: string[]): void {
  try {
    sessionStorage.setItem("fz_pepa", JSON.stringify(respuestas));
    // El flujo clásico invalida cualquier plan previo de la IA.
    sessionStorage.removeItem("fz_pepa_plan");
  } catch {}
}

export function leerRespuestas(): string[] {
  try {
    const crudo = sessionStorage.getItem("fz_pepa");
    return crudo ? (JSON.parse(crudo) as string[]) : [];
  } catch {
    return [];
  }
}
